var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"fill-rule":"evenodd","aria-hidden":"true","d":"M4.377.67l3.5 4a.5.5 0 0 1-.376.83h-7a.5.5 0 0 1-.376-.83l3.5-4a.5.5 0 0 1 .752 0z"}})}
var staticRenderFns = []

export { render, staticRenderFns }